import { getAxiosClient } from "../../axios-client";
import {
  WarehouseServicesGenerateRequestBody,
  WarehouseServicesGenerateResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const warehouseServicesGenerate = async (
  body: WarehouseServicesGenerateRequestBody
) => {
  return await axiosClient.ax.post<WarehouseServicesGenerateResponse>(
    "/WarehouseFacilities/WarehouseServicesGenerate",
    body
  );
};
